import { render, staticRenderFns } from "./MiniTotalsTable.vue?vue&type=template&id=7f2c7ef1&"
import script from "./MiniTotalsTable.vue?vue&type=script&lang=js&"
export * from "./MiniTotalsTable.vue?vue&type=script&lang=js&"
import style0 from "./MiniTotalsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCol,VSimpleTable})
